// src/components/CompromisoInnovacion.tsx
import * as React from 'react'
import { ContactoAliadosForm } from '../contacto-aliados-form'

export default function InnovationCommitment() {
	return (
		<section className="mx-auto w-full max-w-[1400px] bg-white">
			<div className="mx-auto px-6 py-12 md:py-16 md:pr-[120px] md:pl-[120px]">
				<h2 className="text-[24px] leading-[32px] font-medium tracking-tight text-blue-900 md:text-[48px]">
					Compromiso con la{' '}
					<span className="bg-gradient-to-r bg-clip-text text-green-500">
						Innovación
					</span>
				</h2>

				<div className="mt-10 grid grid-cols-1 gap-12 md:grid-cols-2 md:gap-16">
					<div>
						{/* Regla superior con gradiente */}
						<div className="h-[3px] w-full rounded-full bg-gradient-to-r from-blue-500 to-green-500" />
						<div className="mt-8">
							<div className="text-[32px] leading-[45px] font-medium text-blue-900 md:text-[56px]">
								+4.332.000
							</div>
							<p className="mt-6 text-[16px] leading-[30px] text-blue-900 md:text-lg">
								Pólizas expedidas y recaudadas anualmente en nuestra plataforma.
							</p>
						</div>
					</div>

					<div>
						<div className="h-[3px] w-full rounded-full bg-gradient-to-r from-blue-500 to-green-500" />
						<div className="mt-8">
							<div className="text-[32px] leading-[45px] font-medium text-blue-900 md:text-[56px]">
								120
							</div>
							<p className="ext-[16px] mt-6 leading-[30px] text-blue-900 md:text-lg">
								Puntos de venta gestionando el proceso de liquidación de
								comisiones.
							</p>
						</div>
					</div>
				</div>

				<div className="hidden w-full md:mt-[55px] md:block">
					<div className="mx-auto w-full rounded-[28px] bg-blue-900 px-6 py-8 md:px-12 md:py-10">
						<div className="grid grid-cols-1 items-center gap-6 md:grid-cols-2 md:gap-6">
							<div className="flex flex-col gap-4">
								<h3 className="text-3xl leading-tight text-white md:text-[32px] md:leading-[45px] md:font-medium">
									¿Estás interesado en
									<br className="hidden md:block" /> implementar nuestra
									solución?
								</h3>

								<p className="font-inter text-base leading-relaxed text-white md:text-[16px] md:leading-[26px]">
									Escribinos y descubrí cómo digitalizar y optimizar los
									procesos de tu compañía aseguradora.
								</p>
							</div>

							<div className="flex w-full flex-col items-end justify-center">
								<ContactoAliadosForm section="technology" action={''} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
